import { render, staticRenderFns } from "./pagination-dropdown.vue?vue&type=template&id=2a75b777&"
import script from "./pagination-dropdown.vue?vue&type=script&lang=js&"
export * from "./pagination-dropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports